
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'color';
import 'color-string';
import { i as isValidHex, g as getColor } from './color-picker-helper-mixin.js';

var script = {
  name: 'PendoTag',
  components: {
    PendoIcon
  },
  props: {
    type: {
      type: String,
      default: null,
      validator: type => ['success', 'info', 'error', 'warning', 'filter', 'beta', 'sdk'].includes(type)
    },
    color: {
      type: String,
      default: '#BABCC5',
      validator: color => isValidHex(color)
    },
    text: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'medium'
    },
    closable: {
      type: Boolean,
      default: false
    },
    prefixIcon: {
      type: [String, Object],
      default: null
    },
    suffixIcon: {
      type: [String, Object],
      default: null
    },
    round: {
      type: Boolean,
      default: false
    },
    subtle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleObject() {
      if (this.type) {
        return {};
      }

      if (this.subtle) {
        const _getColor = getColor({
          hex: this.color
        }),
              r = _getColor.r,
              g = _getColor.g,
              b = _getColor.b;

        return {
          backgroundColor: `rgba(${r}, ${g}, ${b}, 0.15)`,
          borderColor: 'transparent',
          color: this.color
        };
      }

      return {
        backgroundColor: this.color,
        borderColor: this.color,
        color: '#ffffff'
      };
    },

    tagLabel() {
      if (this.type === 'beta') {
        return 'Beta';
      }

      return this.text || this.label;
    }

  },
  methods: {
    handleClose(event) {
      event.stopPropagation();
      this.$emit('close', event);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "pendo-tag",
    class: ["pendo-tag--" + (_vm.type || 'custom'), "pendo-tag--" + _vm.size, {
      'is-round': _vm.round,
      'is-subtle': _vm.subtle,
      'has-prefix-icon': !!_vm.prefixIcon,
      'has-suffix-icon': !!_vm.suffixIcon
    }],
    style: _vm.styleObject
  }, [_vm.prefixIcon ? _c('pendo-icon', _vm._b({
    staticClass: "pendo-tag__prefix-icon"
  }, 'pendo-icon', _vm.prefixIcon, false)) : _vm._e(), _vm._v(" "), _c('span', [_vm._t("default", [_vm._v("\n            " + _vm._s(_vm.tagLabel) + "\n        ")])], 2), _vm._v(" "), _vm.suffixIcon ? _c('pendo-icon', _vm._b({
    staticClass: "pendo-tag__suffix-icon"
  }, 'pendo-icon', _vm.suffixIcon, false)) : _vm._e(), _vm._v(" "), _vm.closable ? _c('pendo-icon', {
    staticClass: "pendo-tag__close-icon",
    attrs: {
      "size": "14",
      "type": "x"
    },
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-tag.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoTag = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoTag;
